export const AVAILABLE_TIMES = [
  'ทุกช่วงเวลา',
  '8:30 - 12:00',
  '12:00 - 13:00',
  '13:00 - 17:00',
];

export const FORM_LABELS = {
  fullname: 'ชื่อ - นามสกุล',
  mobile: 'เบอร์โทรศัพท์',
  lineId: 'LINE ID',
  email: 'อีเมล',
  province: 'จังหวัด',
  district: 'อำเภอ',
  dealer: 'ผู้จำหน่าย',
  availableTime: 'เวลาที่สะดวกให้ติดต่อ',
  privacy: 'ยอมรับนโยบายคุ้มครองข้อมูลส่วนบุคคล',
  selectVehicle: 'เลือกรุ่นรถ',
  selectDealer: 'เลือกผู้จำหน่าย',
} as const;

export const FORM_PLACEHOLDERS = {
  fullname: 'กรอกชื่อ - นามสกุล',
  mobile: 'กรอกเบอร์ของท่าน',
  lineId: 'กรอก LINE ID',
  email: 'กรอกอีเมล',
  province: 'เลือกจังหวัด',
  district: 'เลือกอำเภอ',
  dealer: 'เลือกผู้จำหน่าย',
} as const;

export const VEHICLE_TYPES = {
  pickup: 'รถปิกอัพ',
  ppv: 'รถมิว-เอ็กซ์',
} as const;

export const FORM_MESSAGES = {
  mobileAsLine: 'ให้ติดต่อโดย add Line ผ่านเบอร์โทรศัพท์',
  mobileAddLine: 'เบอร์โทรสามารถแอดไลน์ได้',
  submitting: 'กำลังส่งข้อมูล...',
  submit: 'ยืนยัน',
  required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
  privacyPolicy: 'นโยบายความเป็นส่วนตัว',
  acceptPrivacy: 'คุณได้อ่านและยอมรับ',
} as const;
